function GDGDetroitLogo({ textColor = '#404040', className = '' }) {
  return (
    <svg
      fill="none"
      height="64"
      width="211"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      title="GDG Detroit Logo"
    >
      <clipPath id="a">
        <path d="m0 0h211v64h-211z" />
      </clipPath>
      <g clipPath="url(#a)">
        <path
          d="m34 19.3a5.6 5.6 0 0 1 -1.2 7.6l-11.4 8.4a5 5 0 0 1 -7.4-1.2 5.6 5.6 0 0 1 1.2-7.7l11.4-8.4a5 5 0 0 1 7.4 1.3"
          fill="#ea4335"
        />
        <path
          d="m34 19.3a5.6 5.6 0 0 1 -1.2 7.6l-11.4 8.4a5 5 0 0 1 -7.4-1.2 5.6 5.6 0 0 1 1.2-7.7l11.4-8.4a5 5 0 0 1 7.4 1.3z"
          stroke="#fff"
          strokeMiterlimit="10"
        />
        <path
          d="m14 27.7a5.6 5.6 0 0 0 1.2 7.6l11.4 8.5a5 5 0 0 0 7.4-1.3 5.6 5.6 0 0 0 -1.2-7.6l-11.4-8.5a5 5 0 0 0 -7.4 1.3"
          fill="#4285f4"
        />
        <path
          d="m14 27.7a5.6 5.6 0 0 0 1.2 7.6l11.4 8.5a5 5 0 0 0 7.4-1.3 5.6 5.6 0 0 0 -1.2-7.6l-11.4-8.5a5 5 0 0 0 -7.4 1.3z"
          stroke="#fff"
          strokeMiterlimit="10"
        />
        <path
          d="m61.4 27.7a5.6 5.6 0 0 1 -1.2 7.6l-11.4 8.5a5 5 0 0 1 -7.4-1.3 5.6 5.6 0 0 1 1.2-7.6l11.4-8.5a5 5 0 0 1 7.4 1.3"
          fill="#f9ab00"
        />
        <path
          d="m61.4 27.7a5.6 5.6 0 0 1 -1.2 7.6l-11.4 8.5a5 5 0 0 1 -7.4-1.3 5.6 5.6 0 0 1 1.2-7.6l11.4-8.5a5 5 0 0 1 7.4 1.3z"
          stroke="#fff"
          strokeMiterlimit="10"
        />
        <path
          d="m41.4 19.3a5.6 5.6 0 0 0 1.2 7.6l11.4 8.4a5 5 0 0 0 7.4-1.2 5.6 5.6 0 0 0 -1.2-7.7l-11.4-8.4a5 5 0 0 0 -7.4 1.3"
          fill="#34a853"
        />
        <path
          d="m41.4 19.3a5.6 5.6 0 0 0 1.2 7.6l11.4 8.4a5 5 0 0 0 7.4-1.2 5.6 5.6 0 0 0 -1.2-7.7l-11.4-8.4a5 5 0 0 0 -7.4 1.3z"
          stroke="#fff"
          strokeMiterlimit="10"
        />
        <path
          d="m82.1 39.9a9 9 0 0 1 -8-4.8 10 10 0 0 1 -1.2-4.9q0-2.7 1.2-4.9a9 9 0 0 1 8-4.7q2 0 3.7.7 1.8.8 2.9 2l-1.5 1.7a6 6 0 0 0 -2.2-1.6 7 7 0 0 0 -9 3q-1 1.6-1 4 0 2.1 1 3.9a7 7 0 0 0 6.1 3.6 7 7 0 0 0 3-.6 7 7 0 0 0 2.1-1.5q.7-.7 1.1-1.8.4-1 .5-2.2h-6.6v-2h8.6v1.2q.1 1.7-.4 3.3t-1.7 2.7a9 9 0 0 1 -6.6 2.8m10.9-18.8h5.4q2.7 0 4.8 1.2a8 8 0 0 1 3.1 3.2q1.2 2.1 1.1 4.8t-1 4.8a8 8 0 0 1 -3.2 3.3q-2.1 1-4.8 1.1h-5.4zm5.4 16.4q3.2 0 5-2 2-1.9 1.9-5.2 0-3.3-1.9-5.2a7 7 0 0 0 -5-2h-3.3v14.4zm20 2.5a9 9 0 0 1 -8-4.8 10 10 0 0 1 -1.3-4.9q0-2.7 1.2-4.9a9 9 0 0 1 8-4.7q2 0 3.8.7 1.6.8 2.8 2l-1.5 1.6a6 6 0 0 0 -2.2-1.6 7 7 0 0 0 -9 3q-1 1.6-1 4 0 2.1 1 3.9a7 7 0 0 0 6.2 3.6 7 7 0 0 0 3-.6 7 7 0 0 0 2-1.5q.8-.7 1.1-1.8.5-1 .5-2.2h-6.6v-2h8.6l.1 1.3q0 1.7-.5 3.3t-1.6 2.7a9 9 0 0 1 -6.5 2.8m15.3-18.8h5.4q2.7 0 4.8 1.2a8 8 0 0 1 3.1 3.2q1.2 2.1 1.1 4.8t-1 4.8a8 8 0 0 1 -3.2 3.3q-2.1 1-4.8 1.1h-5.4zm5.4 16.4q3.2 0 5-2 1.8-1.9 1.8-5.2t-1.8-5.2a7 7 0 0 0 -5-2h-3.3v14.4zm16.5 2.5a6 6 0 0 1 -5.4-3.3q-.8-1.5-.8-3.5 0-1.9.8-3.5a6 6 0 0 1 2.1-2.4q1.5-1 3.2-1t3.1.9 2.1 2.3a8 8 0 0 1 .7 4h-9.8q0 1.5.6 2.5a4 4 0 0 0 3.5 2q2.4 0 3.7-2.4l1.8 1q-.7 1.5-2.2 2.4-1.4 1-3.4 1m3.6-8.3q0-.7-.4-1.5t-1.2-1.3q-.9-.6-2.2-.6t-2.4 1q-1 .9-1.3 2.4zm8.3 8q-.8 0-1.4-.2-.7-.3-1-.7l-.8-1.2q-.3-.7-.3-1.5v-7.3h-2.1v-2h2.2v-3.8h2.1v3.8h3v2h-3v6.7q0 1.2.5 1.6.3.6 1.3.6.8 0 1.3-.3v2zm3.4-12.9h2v2h.1q.4-1 1.5-1.7a4 4 0 0 1 3.6-.5v2.5q-.7-.4-1.8-.4-.9 0-1.6.5t-1.2 1.4-.5 2v7h-2zm13.5 13.2a6 6 0 0 1 -5.5-3.4q-.8-1.6-.8-3.4 0-2 .8-3.5a6 6 0 0 1 5.5-3.3 6 6 0 0 1 5.6 3.3q.8 1.5.8 3.5 0 1.8-.8 3.4a6 6 0 0 1 -5.6 3.4m0-2a4 4 0 0 0 2.1-.6q1-.6 1.6-1.7t.6-2.5-.6-2.6-1.6-1.7a4 4 0 0 0 -4.1 0q-1 .6-1.6 1.7-.6 1-.6 2.6 0 1.5.6 2.5t1.6 1.7a4 4 0 0 0 2 .6m9.5-13.9q-.6 0-1-.5t-.5-1 .5-1.2 1-.5 1.1.5.5 1.1-.5 1.1-1 .5m-1 2.7h2v12.7h-2zm9.2 12.9q-.8 0-1.4-.2-.7-.3-1-.7l-.8-1.2q-.3-.7-.3-1.5v-7.3h-2.2v-2h2.2v-3.8h2.1v3.8h3v2h-3v6.7q0 1.2.5 1.6.3.6 1.3.6.8 0 1.3-.3v2z"
          fill={textColor}
        />
      </g>
    </svg>
  )
}

export default GDGDetroitLogo
